import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export default {
  state: {
    email: '',
    loadingEmail: false,
    logo: '',
    registerUrl: '',
    providerUrl: '',
    loadingLogo: false
  },
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Checkin/index.js